import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import AnalysisPage from "@/pages/AnalysisPage";
import RevealPage from "@/pages/RevealPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import AccessPage from "@/pages/AccessPage";
import AmbientAudio from "@/components/AmbientAudio";

const LANG_CODES = ["en","hi","kn","te","ta","ml","mr","bn","gu","pa","or","as","ur"];

function LangGuard({ children }) {
  return <LanguageProvider>{children}</LanguageProvider>;
}

function AudioGate() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <AmbientAudio />;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <AudioGate />
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/login" element={<AdminPage />} />
        <Route path="/:lang" element={<LangGuard><HomePage /></LangGuard>} />
        <Route path="/:lang/analysis/:leadId" element={<LangGuard><AnalysisPage /></LangGuard>} />
        <Route path="/:lang/reveal/:leadId" element={<LangGuard><RevealPage /></LangGuard>} />
        <Route path="/:lang/legal/:slug" element={<LangGuard><LegalPage /></LangGuard>} />
        <Route path="/:lang/access" element={<LangGuard><AccessPage /></LangGuard>} />
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
